// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1__bac79ca426e0eec12225","cls2":"Comments-cls2___69b7bebbb138857c603 Comments-cls1__bac79ca426e0eec12225"};